// extracted by mini-css-extract-plugin
export default {"wrapper":"ScheduleDescription_wrapper__pNI2U","legend":"ScheduleDescription_legend__r5kK9","content":"ScheduleDescription_content__lP6+8"};